/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.tripenhancer.app/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.tripenhancer.app)

Coded by www.tripenhancer.app

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";

// Article page for deep linking
import Article from "pages/LandingPages/Article";
import ArticleQRCode from "pages/LandingPages/ArticleQRCode";

//internationilization
import { Suspense } from "react";

//Google analytics
import ReactGA from "react-ga4";

export default function App() {
  const { pathname } = useLocation();
  ReactGA.initialize("G-GYFT5H6NK3");

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback="...loading TripEnhancer.app. Welcome!">
        <CssBaseline />
        <Routes>
          {getRoutes(routes)}
          <Route path="/presentation" element={<Presentation />} />
          <Route path="/article/:articleId/qr" element={<ArticleQRCode />} />
          <Route path="/article/:articleId" element={<Article />} />
          <Route path="*" element={<Navigate to="/presentation" />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}
